import {
  CashFlow,
  TransactionCategory,
  TransactionCreditCategory,
  TransactionExpenseCategory,
  TransactionIncomeCategory,
} from '@algoan/dashboard/model';

export const timelineCashFlows: TransactionCategory[] = [
  TransactionExpenseCategory.RENT,
  TransactionCreditCategory.LOAN_REPAYMENT,
  TransactionCreditCategory.LOAN_REPAYMENT_REAL_ESTATE,
  TransactionCreditCategory.LOAN_REPAYMENT_PERSONAL,
  TransactionCreditCategory.LOAN_REPAYMENT_REVOLVING,
  TransactionCreditCategory.LOAN_REPAYMENT_FAST,
  TransactionCreditCategory.LOAN_REPAYMENT_STUDENT,
  TransactionCreditCategory.SPLIT_PAYMENT,
  TransactionIncomeCategory.WAGE,
  TransactionIncomeCategory.RENTAL_INCOME,
  TransactionIncomeCategory.RETIREMENT_PENSION,
];

export type RegularCashFlow = Required<CashFlow>;
